if($('.carousel-module-swipe').length){
  hp.swipers = hp.swipers || {};
  var carousel_module_swipe = 
  {
    initialized: false
  };

  carousel_module_swipe.init = function(){
    var carouselModuleProps = {
      navigation: {
        nextEl: ".right-arrow-svg-carousel",
        prevEl: ".left-arrow-svg-carousel",
      },
      slidesPerView: 1.08,
      spaceBetween: 20,
      loop: true,
      loopAdditionalSlides: 1,
      breakpoints: {
        1024: {
          slidesPerView: 1.08,
          spaceBetween: 20
        },
        767: {
          slidesPerView: 1.08,
          spaceBetween: 0
        },
        640: {
          slidesPerView: 1.08,
          spaceBetween: 0
        },
        320: {
          slidesPerView: 1.08,
          spaceBetween: 0
        }
      }
    }
    var carouselModuleMethods = {
      resizeHandler: true,
      a11ySwiper: true
    }
    carousel_module_swipe.instances = hp.swiperInstance('.carousel-module-swipe', carouselModuleProps, carouselModuleMethods);
    carousel_module_swipe.initialized = true;
  }
    
  hp.swipers.carousel_module_swipe=carousel_module_swipe;
}